import {
   
  GET_ALL_MAIN_REPORTS_FAILURE,
  GET_ALL_MAIN_REPORTS_REQUEST,
  GET_ALL_MAIN_REPORTS_SUCCESS,
  GET_FINANCIAL_REPORTS_FAILURE,
  GET_FINANCIAL_REPORTS_REQUEST,
     GET_FINANCIAL_REPORTS_SUCCESS,
     GET_OFFICE_REPORTS_FAILURE, 
     GET_OFFICE_REPORTS_REQUEST, 
     GET_OFFICE_REPORTS_SUCCESS, 
     GET_PAYMENT_METHODS_REPORT_REQUEST,
     GET_PAYMENT_METHODS_REPORT_SUCCESS,
     GET_PAYMENT_METHODS_REPORT_FAILURE,
     GET_RECENT_NOTIFICATIONS_REQUEST,
     GET_RECENT_NOTIFICATIONS_SUCCESS,
     GET_RECENT_NOTIFICATIONS_FAILURE,
  } from "../../../Utils/Constant";
  
  const initialState = {
    frontDeskReport: {},      
    financialReport:{},
    mainReports:{},
    paymentMethodsReport: {},
    loading: false,     
    error: null,       
    recentNotifications: [],
    notificationRefreshComplete: false, 
  };
  
  export const DashboardReducer = (state = initialState, action) => {
    switch (action.type) {
      // GET office front desk report
      case GET_OFFICE_REPORTS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_OFFICE_REPORTS_SUCCESS:
        return {
          ...state,
          frontDeskReport: action.payload,
          loading: false,
          error: null,
        };
      case GET_OFFICE_REPORTS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };

      // Financial report

      case GET_FINANCIAL_REPORTS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_FINANCIAL_REPORTS_SUCCESS:
        return {
          ...state,
          financialReport: action.payload,
          loading: false,
          error: null,
        };
      case GET_FINANCIAL_REPORTS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };

      // ALL MAIN REPORTS

      case GET_ALL_MAIN_REPORTS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_ALL_MAIN_REPORTS_SUCCESS:
        return {
          ...state,
          mainReports: action.payload,
          loading: false,
          error: null,
        };
      case GET_ALL_MAIN_REPORTS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };

      // Payment Methods Report
      case GET_PAYMENT_METHODS_REPORT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_PAYMENT_METHODS_REPORT_SUCCESS:
        return {
          ...state,
          paymentMethodsReport: action.payload,
          loading: false,
          error: null,
        };
      case GET_PAYMENT_METHODS_REPORT_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };

      // Recent Notifications
      case GET_RECENT_NOTIFICATIONS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          notificationRefreshComplete: false, // reset on request
        };
      case GET_RECENT_NOTIFICATIONS_SUCCESS:
        return {
          ...state,
          recentNotifications: action.payload,
          loading: false,
          error: null,
          notificationRefreshComplete: true, // set to true on success
        };
      case GET_RECENT_NOTIFICATIONS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          notificationRefreshComplete: true, // set to true even on failure
        };
    case 'RESET_NOTIFICATION_REFRESH_FLAG':
      return {
        ...state,
        notificationRefreshComplete: false,
      };

      default:
        return state;
    }
  };
  